import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.suppliers;
export const suppliersRoute = {
    path: rootPath,
    lazy: async () => {
        const { SuppliersContainer } = await import('@/admin/modules/suppliers');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(SuppliersContainer, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
